import { alignItemsStyles, backgroundStyles, borderBottomStyles, borderLeftStyles, borderRightStyles, borderStyles, borderTopStyles, boxShadowStyles, boxSizingStyles, colorStyles, type CSSCursor, cursorStyles, displayStyles, flexDirectionStyles, flexWrapStyles, justifyContentStyles, lineHeightStyles, overflowStyles, pointerEventsStyles, positionStyles, spaceStyles, textAlignItemsStyles, textOverflowStyles, transformStyles, userSelectStyles, valueStyles, whiteSpaceStyles, type AlignItems, type BackgroundAttachment, type BackgroundClip, type BackgroundOrigin, type BackgroundPosition, type BackgroundRepeat, type BackgroundSize, type BorderStyle, type BoxSizing, type ColorKey, type Display, type FlexDirection, type FlexWrap, type JustifyContent, type Overflow, type PointerEvents, type Position, type SpaceKey, type TextAlign, type TextOverflow, type TransformOrigin, type TransformStyle, type UserSelect, type ValueKey, type WhiteSpace, type CssValue, type BoxShadow, type BackgroundImage, type Transform, type ObjectFit, objectFitStyles, type FontStyle, type FontFamily, fontStyles, type Visibility, visibilityStyles, gridStyles } from './extendStyles'

export type ExtendStyleProps = Partial<Record<SpaceKey, CssValue>> & Partial<Record<ValueKey, CssValue>> & Partial<Record<ColorKey, string>> & {
  lineHeight?: CssValue
  boxSizing?: BoxSizing
  position?: Position
  display?: Display
  gridArea?: string
  gridAutoColumns?: string
  gridAutoFlow?: string
  gridAutoRows?: string
  gridColumn?: string
  gridColumnEnd?: string
  gridColumnGap?: string
  gridColumnStart?: string
  gridGap?: string
  gridRow?: string
  gridRowEnd?: string
  gridRowGap?: string
  gridRowStart?: string
  gridTemplate?: string
  gridTemplateAreas?: string
  gridTemplateColumns?: string
  gridTemplateRows?: string
  justifyContent?: JustifyContent
  alignItems?: AlignItems
  textAlign?: TextAlign
  textOverflow?: TextOverflow
  whiteSpace?: WhiteSpace
  flexDirection?: FlexDirection
  flexWrap?: FlexWrap
  borderStyle?: BorderStyle
  borderTopStyle?: BorderStyle
  borderRightStyle?: BorderStyle
  borderBottomStyle?: BorderStyle
  borderLeftStyle?: BorderStyle
  overflow?: Overflow
  overflowX?: Overflow
  overflowY?: Overflow
  cursor?: CSSCursor
  boxShadow?: BoxShadow
  pointerEvents?: PointerEvents
  backgroundImage?: BackgroundImage
  backgroundSize?: BackgroundSize
  backgroundPosition?: BackgroundPosition
  backgroundRepeat?: BackgroundRepeat
  backgroundAttachment?: BackgroundAttachment
  backgroundClip?: BackgroundClip
  backgroundOrigin?: BackgroundOrigin
  transform?: Transform
  transformOrigin?: TransformOrigin
  transformStyle?: TransformStyle
  userSelect?: UserSelect
  objectFit?: ObjectFit
  fontStyle?: FontStyle
  fontFamily?: FontFamily
  visibility?: Visibility
}

export const makeExtendStyle = <P>(props: P & ExtendStyleProps) => {
  const {
    lineHeight,
    boxSizing,
    position,
    display,
    gridArea,
    gridAutoColumns,
    gridAutoFlow,
    gridAutoRows,
    gridColumn,
    gridColumnEnd,
    gridColumnGap,
    gridColumnStart,
    gridGap,
    gridRow,
    gridRowEnd,
    gridRowGap,
    gridRowStart,
    gridTemplate,
    gridTemplateAreas,
    gridTemplateColumns,
    gridTemplateRows,
    justifyContent,
    alignItems,
    textAlign,
    textOverflow,
    whiteSpace,
    flexDirection,
    flexWrap,
    flexShrink,
    flexGrow,
    backgroundColor,
    backgroundImage,
    backgroundSize,
    backgroundPosition,
    backgroundRepeat,
    backgroundAttachment,
    backgroundClip,
    backgroundOrigin,
    color,
    borderStyle,
    borderTopStyle,
    borderRightStyle,
    borderBottomStyle,
    borderLeftStyle,
    borderColor,
    borderTopColor,
    borderRightColor,
    borderBottomColor,
    borderLeftColor,
    borderWidth,
    borderTopWidth,
    borderRightWidth,
    borderBottomWidth,
    borderLeftWidth,
    borderRadius,
    borderTopLeftRadius,
    borderTopRightRadius,
    borderBottomLeftRadius,
    borderBottomRightRadius,
    flex,
    height,
    minHeight,
    maxHeight,
    width,
    minWidth,
    maxWidth,
    left,
    right,
    top,
    bottom,
    overflow,
    overflowX,
    overflowY,
    zIndex,
    fontSize,
    fontWeight,
    opacity,
    cursor,
    boxShadow,
    pointerEvents,
    transform,
    transformOrigin,
    transformStyle,
    userSelect,
    objectFit,
    fontFamily,
    fontStyle,
    visibility,
    ...rest
  } = props

  const shouldPassProps: Record<string, unknown> = {}
  const keys = Object.keys(rest)
  const sortedSpaceStyles = keys.map((key) => {
    const spaceStyle = spaceStyles[key as SpaceKey]
    const value = rest[key as SpaceKey]
    if (spaceStyle && value !== undefined) {
      return spaceStyle(value)
    }
    else {
      shouldPassProps[key] = value
    }
    return undefined
  })

  return {
    extendStyles: [
      cursor !== undefined && cursorStyles.cursor(cursor),
      boxShadow !== undefined && boxShadowStyles.boxShadow(boxShadow),
      boxSizing !== undefined && boxSizingStyles[boxSizing],
      pointerEvents !== undefined && pointerEventsStyles[pointerEvents],
      lineHeight !== undefined && lineHeightStyles.lineHeight(lineHeight),
      position !== undefined && positionStyles[position],
      display !== undefined && displayStyles[display],
      gridArea !== undefined && gridStyles.gridArea(gridArea),
      gridAutoColumns !== undefined && gridStyles.gridAutoColumns(gridAutoColumns),
      gridAutoFlow !== undefined && gridStyles.gridAutoFlow(gridAutoFlow),
      gridAutoRows !== undefined && gridStyles.gridAutoRows(gridAutoRows),
      gridColumn !== undefined && gridStyles.gridColumn(gridColumn),
      gridColumnEnd !== undefined && gridStyles.gridColumnEnd(gridColumnEnd),
      gridColumnGap !== undefined && gridStyles.gridColumnGap(gridColumnGap),
      gridColumnStart !== undefined && gridStyles.gridColumnStart(gridColumnStart),
      gridGap !== undefined && gridStyles.gridGap(gridGap),
      gridRow !== undefined && gridStyles.gridRow(gridRow),
      gridRowEnd !== undefined && gridStyles.gridRowEnd(gridRowEnd),
      gridRowGap !== undefined && gridStyles.gridRowGap(gridRowGap),
      gridRowStart !== undefined && gridStyles.gridRowStart(gridRowStart),
      gridTemplate !== undefined && gridStyles.gridTemplate(gridTemplate),
      gridTemplateAreas !== undefined && gridStyles.gridTemplateAreas(gridTemplateAreas),
      gridTemplateColumns !== undefined && gridStyles.gridTemplateColumns(gridTemplateColumns),
      gridTemplateRows !== undefined && gridStyles.gridTemplateRows(gridTemplateRows),
      justifyContent !== undefined && justifyContentStyles[justifyContent],
      alignItems !== undefined && alignItemsStyles[alignItems],
      textAlign !== undefined && textAlignItemsStyles[textAlign],
      textOverflow !== undefined && textOverflowStyles[textOverflow],
      whiteSpace !== undefined && whiteSpaceStyles[whiteSpace],
      flexDirection !== undefined && flexDirectionStyles[flexDirection],
      flexWrap !== undefined && flexWrapStyles[flexWrap],
      borderStyle !== undefined && borderStyles[borderStyle],
      borderTopStyle !== undefined && borderTopStyles[borderTopStyle],
      borderRightStyle !== undefined && borderRightStyles[borderRightStyle],
      borderBottomStyle !== undefined && borderBottomStyles[borderBottomStyle],
      borderLeftStyle !== undefined && borderLeftStyles[borderLeftStyle],
      overflow !== undefined && overflowStyles[overflow],
      overflowX !== undefined && overflowStyles[overflowX],
      overflowY !== undefined && overflowStyles[overflowY],
      visibility !== undefined && visibilityStyles[visibility],
      color !== undefined && colorStyles.color(color),
      backgroundColor !== undefined && colorStyles.backgroundColor(backgroundColor),
      borderColor !== undefined && colorStyles.borderColor(borderColor),
      borderTopColor !== undefined && colorStyles.borderTopColor(borderTopColor),
      borderRightColor !== undefined && colorStyles.borderRightColor(borderRightColor),
      borderBottomColor !== undefined && colorStyles.borderBottomColor(borderBottomColor),
      borderLeftColor !== undefined && colorStyles.borderLeftColor(borderLeftColor),
      flex !== undefined && valueStyles.flex(flex),
      flexShrink !== undefined && valueStyles.flexShrink(flexShrink),
      flexGrow !== undefined && valueStyles.flexGrow(flexGrow),
      height !== undefined && valueStyles.height(height),
      minHeight !== undefined && valueStyles.minHeight(minHeight),
      maxHeight !== undefined && valueStyles.maxHeight(maxHeight),
      width !== undefined && valueStyles.width(width),
      minWidth !== undefined && valueStyles.minWidth(minWidth),
      maxWidth !== undefined && valueStyles.maxWidth(maxWidth),
      left !== undefined && valueStyles.left(left),
      right !== undefined && valueStyles.right(right),
      top !== undefined && valueStyles.top(top),
      bottom !== undefined && valueStyles.bottom(bottom),
      borderWidth !== undefined && valueStyles.borderWidth(borderWidth),
      borderTopWidth !== undefined && valueStyles.borderTopWidth(borderTopWidth),
      borderRightWidth !== undefined && valueStyles.borderRightWidth(borderRightWidth),
      borderBottomWidth !== undefined && valueStyles.borderBottomWidth(borderBottomWidth),
      borderLeftWidth !== undefined && valueStyles.borderLeftWidth(borderLeftWidth),
      borderRadius !== undefined && valueStyles.borderRadius(borderRadius),
      borderTopLeftRadius !== undefined && valueStyles.borderTopLeftRadius(borderTopLeftRadius),
      borderTopRightRadius !== undefined && valueStyles.borderTopRightRadius(borderTopRightRadius),
      borderBottomLeftRadius !== undefined && valueStyles.borderBottomLeftRadius(borderBottomLeftRadius),
      borderBottomRightRadius !== undefined && valueStyles.borderBottomRightRadius(borderBottomRightRadius),
      zIndex !== undefined && valueStyles.zIndex(zIndex),
      fontSize !== undefined && valueStyles.fontSize(fontSize),
      fontWeight !== undefined && valueStyles.fontWeight(fontWeight),
      opacity !== undefined && valueStyles.opacity(opacity),
      backgroundImage !== undefined && backgroundStyles.backgroundImage(backgroundImage),
      backgroundSize !== undefined && backgroundStyles.backgroundSize(backgroundSize),
      backgroundPosition !== undefined && backgroundStyles.backgroundPosition(backgroundPosition),
      backgroundRepeat !== undefined && backgroundStyles.backgroundRepeat(backgroundRepeat),
      backgroundAttachment !== undefined && backgroundStyles.backgroundAttachment(backgroundAttachment),
      backgroundClip !== undefined && backgroundStyles.backgroundClip(backgroundClip),
      backgroundOrigin !== undefined && backgroundStyles.backgroundOrigin(backgroundOrigin),
      transform !== undefined && transformStyles.transform(transform),
      transformOrigin !== undefined && transformStyles.transformOrigin(transformOrigin),
      transformStyle !== undefined && transformStyles.transformStyle(transformStyle),
      userSelect !== undefined && userSelectStyles.userSelect(userSelect),
      objectFit !== undefined && objectFitStyles.objectFit(objectFit),
      fontStyle !== undefined && fontStyles.fontStyle(fontStyle),
      fontFamily !== undefined && fontStyles.fontFamily(fontFamily),
      sortedSpaceStyles,
    ],
    ...shouldPassProps as Omit<P, keyof ExtendStyleProps>,
  }
}
